import { render } from "./switch-input.vue?vue&type=template&id=b5e06f0e&ts=true"
import script from "./switch-input.vue?vue&type=script&lang=ts"
export * from "./switch-input.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__